"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowingAbsentKey = allowingAbsentKey;
exports.coercedString = coercedString;
const zod_1 = require("zod");
function allowingAbsentKey(schema) {
    const optional = schema.optional();
    return optional;
}
function coercedString() {
    return zod_1.z.preprocess((value) => String(value), zod_1.z.string());
}
//# sourceMappingURL=zod-field-presence.js.map